import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Logout from './views/Logout.vue'
import Login from './views/Login.vue'
import InspectionArea from './views/Area.vue'

import store from './store.js';

Vue.use(Router)



const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/area/:id',
      name: 'inspectionArea',
      component: InspectionArea
    },
    {
      path: '/area',
      redirect: '/'
    },
    {
      path: '*',
      redirect: '/'
    }

  ]
});

/*
    This will check to see if the user is authenticated or not.
*/
router.beforeEach( (to, from, next) => {
  if ( ! store.state.loggedIn && to.path != '/login' ){
    next( 'login' );
  }else{
    next();
  }
} );

/*
  This will redirect to home from login page (once logged in)
  */
router.beforeEach( (to, from, next) => {

  if ( store.state.loggedIn && to.path == '/login' ){
    next( '/' );
  }else{
    next();
  }
} );

export default router;
